<div class="flex items-center justify-center bg-gradient-to-br from-primary-light to-white py-16 md:py-24 px-4">
  <div class="container max-w-2xl text-center">
    <!-- Error Code -->
    <h1 class="text-6xl lg:text-8xl xl:text-9xl text-primary mb-4 font-bold">404</h1>

    <!-- Title -->
    <h2 class="text-2xl lg:text-4xl font-semibold text-gray-900 mb-4">
      {{ 'NOT_FOUND.TITLE' | translate }}
    </h2>

    <!-- Description -->
    <p class="text-gray-600 mb-8 text-lg lg:text-xl max-w-md mx-auto">
      {{ 'NOT_FOUND.DESCRIPTION' | translate }}
    </p>

    <!-- Action Buttons -->
    <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
      <a [routerLink]="['/home']"
         class="rounded-full bg-primary text-white text-sm cursor-pointer text-center py-3 px-8 lg:hover:bg-main-600 transition w-full sm:w-auto">
        {{ 'NOT_FOUND.BACK_TO_HOME' | translate }}
      </a>
    </div>

    <!-- Additional Links -->
    <div class="mt-12 pt-8 border-t border-gray-200">
      <p class="text-sm text-gray-500 mb-4">{{ 'NOT_FOUND.YOU_CAN_ALSO' | translate }}</p>
      <div class="flex flex-wrap justify-center gap-4 text-sm">
        <a [routerLink]="['/auth/signup']" class="text-primary hover:text-main-600 hover:underline transition">
          {{ 'NOT_FOUND.CREATE_ACCOUNT' | translate }}
        </a>
        <span class="text-gray-300">•</span>
        <a [routerLink]="['/contact']" class="text-primary hover:text-main-600 hover:underline transition">
          {{ 'NOT_FOUND.CONTACT_US' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
